import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { stringify } from 'query-string';
import type { RootState } from '../../state/store';
import { WHITELISTED_DASHBOARD_PATHS } from '../constants';
import { buildFilterQueryParams } from '../utils';

export const useFilterNavigate = () => {
  const navigateTo = useNavigate();
  const { dates: dateFilters, timeRange } = useSelector((state: RootState) => state.filters);

  const queryParams = useMemo(() => {
    const params = buildFilterQueryParams({
      dateRange: dateFilters as [string, string],
      timeRange: timeRange as [[number, number], [number, number]]
    });
    const queryString = stringify(params, { encode: true, sort: false });
    return queryString ? `?${queryString}` : "";
  }, [dateFilters, timeRange]);

  const navigateWithFilters = (route: string) => {
    if (WHITELISTED_DASHBOARD_PATHS.includes(route)) {
      navigateTo(route);
      return;
    }
    navigateTo(route + queryParams);
  };
  return navigateWithFilters;
};
